export default "__VITE_ASSET__Do7Q$2Sm__"